import * as React from 'react';
import { ConstantNeedModel } from 'rlv-common';
import { NavigationAction } from '../../../routing/StateMachineTypes';
import { NeedSubPageProps } from '../Needs.types';
import { constantYearsTermValidator } from '../../../validation/ConstantNeedBlock';
import { SliderForm, SliderFormProps } from '../forms/SliderForm/SliderForm';
import {
  ComponentFieldNames,
  CONSTANT_SLIDER_FORM_TEMPLATES_LAYOUT,
  getPeriodInYears
} from '../NeedsPageContainer.data';

export const ConstantPeriodInYearsPage = ({
  valueRanges,
  storeState,
  handleAction,
  tracker
}: NeedSubPageProps) => {
  const SETUP = {
    componentFieldName: ComponentFieldNames.PeriodInYears,
    sliderConfig: {
      min: valueRanges.insuranceDuration.min,
      max: valueRanges.insuranceDuration.max,
      step: valueRanges.insuranceDuration.increment,
      text: 'Jahre',
      trackerUpdate: (value: number) =>
        tracker.updateTariffOptions({
          VersLZ: value
        }),
      textInSingular: 'Jahr'
    },
    templateLayout: CONSTANT_SLIDER_FORM_TEMPLATES_LAYOUT.periodInYears,
    formValues: {
      periodInYears: getPeriodInYears(
        storeState.periodInYears,
        valueRanges.insuranceDuration.max
      )
    },
    validationSchema: constantYearsTermValidator(valueRanges),
    onHandleSliderFormActions: (
      { periodInYears }: { periodInYears: number },
      navigationAction: NavigationAction
    ): void => {
      if (navigationAction === NavigationAction.NEXT) {
        storeState.update({ periodInYears });
      }

      handleAction(navigationAction);
    },
    handleNavigateNoSubmitAction: () => {
      handleAction(NavigationAction.BACK);
    }
  };

  // TODO: type aren't well defined to support some optional params not passed here, thus the unknown
  return <SliderForm<ConstantNeedModel> {...SETUP as unknown as SliderFormProps<ConstantNeedModel>} />;
};
